import { useEffect, useState } from "react";
import { Field } from "../types/report";
import { FILTERS } from "@/common/filters";
import { DatasetName } from "@/common/constants";
import { applyFieldNameOverride } from "@/common/user";

export const useAvailableFilterFields = (
  datasetName: DatasetName,
  fieldNameOverrides?: Partial<Record<string, string>>,
): Field[] | null => {
  const [fields, setFields] = useState<Field[] | null>(null);

  useEffect(() => {
    const fields = Object.values(FILTERS)
      .filter((dim) => dim.datasetName.includes(datasetName))
      .map((dim): Field => {
        return {
          name: dim.field,
          display_name: applyFieldNameOverride(
            dim.label,
            dim.filter,
            fieldNameOverrides,
          ),
          type: dim.type,
          is_dimension: true,
          group: dim.group,
        };
      });
    setFields(fields);
  }, [datasetName, fieldNameOverrides]);

  return fields;
};
